import { render, staticRenderFns } from "./show_form.vue?vue&type=template&id=3a31a20c&scoped=true&"
import script from "./show_form.vue?vue&type=script&lang=js&"
export * from "./show_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31a20c",
  null
  
)

export default component.exports